import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function CategorisRecentPost() {
  return (
    <>
      <div className="recentpost_box mb-5 ">
        <div className="titlerescent pb-3">
          <h3>Recent Posts</h3>
        </div>
        <Row>
          <Col lg={12} sm={6}>
            <div className="recent-posts mb-4">
              <Row>
                <Col md={3} lg={4} xs={3}>
                  <div className="postthumbnail">
                    <Link to="/article/eco-friendly-safari-tips-how-to-travel-sustainably">
                      <img
                        src="https://www.walkintothewild.in/storage/article/44/article_banner-1722431856.jpg"
                        alt=""
                        className="w-100"
                      />
                    </Link>
                  </div>
                </Col>
                <Col md={9} lg={8} xs={9}>
                  <div className="posttitles">
                    <h6>
                      <Link to="/article/eco-friendly-safari-tips-how-to-travel-sustainably">
                        Eco-Friendly Safari Tips: How to Travel Sustainably
                      </Link>
                    </h6>
                  </div>
                  <ul className="artical-info p-0 justify-content-start gap-1 mb-0">
                    <li className="d-flex align-items-center gap-2">
                      <i className="far fa-comments"></i>
                      <Link to="/article/eco-friendly-safari-tips-how-to-travel-sustainably">
                        0 Comments
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={12} sm={6}>
            <div className="recent-posts mb-4">
              <Row>
                <Col md={3} lg={4} xs={3}>
                  <div className="postthumbnail">
                    <Link to="/article/group-safaris-vs-private-safaris-which-is-right-for-you">
                      <img
                        src="https://www.walkintothewild.in/storage/article/38/article_banner-1722431752.jpg"
                        alt=""
                        className="w-100"
                      />
                    </Link>
                  </div>
                </Col>
                <Col lg={8} md={9} xs={9}>
                  <div className="posttitles">
                    <h6>
                      <Link to="/article/group-safaris-vs-private-safaris-which-is-right-for-you">
                        Group Safaris vs. Private Safaris: Which is Right for
                        You?
                      </Link>
                    </h6>
                  </div>
                  <ul className="artical-info p-0 justify-content-start gap-1 mb-0">
                    <li className="d-flex align-items-center gap-2">
                      <i className="far fa-comments"></i>
                      <Link to="/article/group-safaris-vs-private-safaris-which-is-right-for-you">
                        1 Comments
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={12} sm={6}>
            <div className="recent-posts mb-4">
              <Row>
                <Col md={3} lg={4} xs={3}>
                  <div className="postthumbnail">
                    <Link to="/article/top-10-safari-destinations-you-must-visit-in-2024-in-india">
                      <img
                        src="https://www.walkintothewild.in/storage/article/41/article_banner-1722431809.jpg"
                        alt=""
                        className="w-100"
                      />
                    </Link>
                  </div>
                </Col>
                <Col md={9} lg={8} xs={9}>
                  <div className="posttitles">
                    <h6>
                      <Link to="/article/top-10-safari-destinations-you-must-visit-in-2024-in-india">
                        Top 10 Safari Destinations You Must Visit in 2024 in
                        India
                      </Link>
                    </h6>
                  </div>
                  <ul className="artical-info p-0 justify-content-start gap-1 mb-0">
                    <li className="d-flex align-items-center gap-2">
                      <i className="far fa-comments"></i>
                      <Link to="/article/top-10-safari-destinations-you-must-visit-in-2024-in-india">
                        1 Comments
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <div className="topics_box">
        <div className="titlerescent pb-3">
          <h3>Category</h3>
        </div>
        <div className="topics_listing">
          <ul>
            <Row className="gx-lg-0 gx-sm-5">
              <Col lg={12} sm={6}>
                <li>
                  {/* <Link href="/article/topic/animal" className="link active"> */}
                  <Link to="/article/topic/animal" className="link">
                    Animals <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
              <Col lg={12} sm={6}>
                <li>
                  <Link to="/animal" className="link">
                    Birds <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
              <Col lg={12} sm={6}>
                <li>
                  <Link to="/animal" className="link">
                    Gadgets <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
              <Col lg={12} sm={6}>
                <li>
                  <Link to="/animal" className="link">
                    Safari <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
              <Col lg={12} sm={6}>
                <li>
                  <Link to="/animal" className="link">
                    Tips <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
              <Col lg={12} sm={6}>
                <li>
                  <Link to="/animal" className="link">
                    Wild Life <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </Col>
            </Row>
          </ul>
        </div>
      </div>
    </>
  );
}

export default CategorisRecentPost;
